var HorizontalFields = require("./HorizontalFields");

module.exports = function(form, layout, scale, label_size){
  return HorizontalFields({
    fields: form.Form_buildSchema(),
    errors: form.state.errors || {},
    buildInput: form.Form_buildInput,
    layout: layout,
    scale: scale,
    label_size: label_size
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/react-loose-forms.bootstrap3/layouts/ezHorizontalFields.js
// module id = 25
// module chunks = 0 1 2 3 4